<template>
  <div>
    <el-button style="margin-bottom: 20px" type="primary" @click="setsu('null')"
      >添加原因</el-button
    >
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        label="名称"
        align="center"
        prop="reason"
      ></el-table-column>
      <el-table-column
        label="排序"
        align="center"
        prop="sort"
      ></el-table-column>
      <el-table-column label="操作" align="center" prop="icon" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            @click="UpdateConfigTypeButton(scope.row)"
            >编辑</el-button
          >
          <el-popconfirm
            title="确定删除该品牌吗？"
            @confirm="delHandle(scope.row.id)"
          >
            <el-button type="danger" plain slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" :current-page="current"
			:page-size="size" :total="total">
		</el-pagination> -->
    <el-dialog
      title="原因"
      :visible.sync="dialogVisible"
      width="800px"
      append-to-body
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        ref="editForm"
        label-width="100px"
        class="demo-editForm"
      >
        <el-form-item label-width="100px" label="名称">
          <el-input v-model="reason"></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="排序">
          <el-input v-model="sort" type="number"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">完成</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import VploadImg from "../inc/VploadImgTwo";
export default {
  name: "cause",
  components: {
    VploadImg,
  },
  data() {
    return {
      searchForm: {},
      shopForm: {},
      delBtlStatu: true,
      tableData: [],
      multipleSelection: [],
      filesd: [],
      editForm: {},
      total: 0,
      size: 10,
      current: 1,
      dialogVisible: false,
      reason: "",
      sort: 0,
      id: "",
    };
  },
  created() {
    this.getConfigType();
  },
  methods: {
    delHandle(id) {
      this.$axios
        .post("/admin/billReturnReason/delBillReturnReason", {
          id: id,
        })
        .then((res) => {
          this.getConfigType();
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {},
          });
        });
    },

    setsu() {
      this.id = "";
      this.reason = "";
      this.sort = 0;
      this.dialogVisible = true;
    },
    getImg(url, add) {
      if (add == 1) {
        this.imgUrl = url;
      } else if (add == 0) {
        this.imgUrl = "";
      }
    },

    handleClose() {
      this.dialogVisible = false;
    },

    submitForm() {
      if (this.reason == "") {
        this.$message({
          showClose: true,
          message: "请输入名称",
          type: "info",
          onClose: () => {},
        });
        return;
      }
      if (this.id) {
        this.$axios
          .post("/admin/billReturnReason/updBillReturnReason", {
            id: this.id,
            reason: this.reason,
            sort: this.sort,
          })
          .then((res) => {
            this.dialogVisible = false;
            this.getConfigType();
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
          });
      } else {
        this.$axios
          .post("/admin/billReturnReason/addBillReturnReason", {
            reason: this.reason,
            sort: this.sort,
          })
          .then((res) => {
            this.dialogVisible = false;
            this.getConfigType();
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
          });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delBtlStatu = val.length == 0;
    },

    handleSizeChange(val) {
      this.size = val;
      this.getConfigType();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getConfigType();
    },

    //获取常量数据配置列表
    getConfigType() {
      this.$axios
        .post("/admin/billReturnReason/getBillReturnReasonList", {})
        .then((res) => {
          this.tableData = res.data;
        });
    },
    UpdateConfigTypeButton(id) {
      this.id = id.id;
      this.reason = id.reason;
      this.sort = id.sort;
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
